import { AccessibilityImages, AccessibilityImagesQuery, AccessibilityImagesRequest } from "../models/AccessibilityImages";
import axios from "../utils/axios";
import {AxiosRequestConfig} from "axios";
// @ts-ignore
import uuid from 'react-uuid'

export function createUnitImage(data: AccessibilityImagesRequest, token: string, controller?: AbortController | null) {
  const formData = new FormData();
  const config: AxiosRequestConfig = {
    headers: { Authorization: "Token " + token },
  }

  if (controller) {
    config.signal = controller.signal
  }

  Object.entries(data).forEach(([key, value]) => {
    if (value) {
      if (key === 'image') {
        const fileName = value.name.substr(0, value.name.indexOf('.'))
        const extension = value.name.substr(value.name.indexOf('.'))
        value = new File(
          [value],
          `${fileName}_${uuid()}${extension}`,
          { type: value.type }
        )
      }
      formData.append(key, value as any);
    }
  })

  return new Promise<AccessibilityImages>((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_API_DOMAIN}/accessibility-images/`,
        formData,
        config,
      )
      .then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchUnitImages(unitId: string, token: string) {
  return new Promise<AccessibilityImagesQuery>((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_API_DOMAIN}/accessibility-images/?accessibility_unit__id=${unitId}`,
        {
          headers: { Authorization: "Token " + token },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchUnitImagesByProperty(token: string, propertyId: string) {
  let params: any = {
    accessibility_unit__property__id: propertyId,
    limit: 99999,
  }
  return new Promise<number>((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_API_DOMAIN}/accessibility-images/`,
        {
          headers: { Authorization: "Token " + token },
          params: params
        }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchUnitImagesByCompanyId(token: string, companyId: string) {
  let params: any = {
    accessibility_unit__property__company: companyId,
    limit: 99999,
  }

  return new Promise<any>((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_API_DOMAIN}/accessibility-images/`,
        {
          headers: { Authorization: "Token " + token },
          params: params
        }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function fetchCountUnitImages(token: string, companyId?: string) {
  let params: any = {}
  if (companyId) params.accessibility_unit__property__company = companyId
  return new Promise<number>((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_API_DOMAIN}/accessibility-images/?fields=count`,
        {
          headers: { Authorization: "Token " + token },
          params: params
        }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.count);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function deleteUnitImage(id: string, token: string) {
  return new Promise<any>((resolve, reject) => {
    axios
      .delete(`${process.env.REACT_APP_API_DOMAIN}/accessibility-images/${id}/`,
        { headers: { 'Authorization': 'Token ' + token } }
      )
      .then((response) => {
        if (response.status === 204) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function unitUpdateImage(id: string, data: AccessibilityImagesRequest, token: string) {
  return new Promise<AccessibilityImages>((resolve, reject) => {
    axios
      .patch(`${process.env.REACT_APP_API_DOMAIN}/accessibility-images/${id}/`, data,
        { headers: { 'Authorization': 'Token ' + token } }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function unitPartialUpdateImage(id: string, data: Partial<AccessibilityImagesRequest>, token: string) {
  const formData = new FormData()
  Object.entries(data).forEach(([key, value]) => {
    if (value) {
      if (value instanceof Array) {
        value.forEach(val => {
          formData.append(key, val);
        })
      } else {
        formData.append(key, value as any);
      }
    }
  })

  const isEmptyFormData = formData.entries().next().done

  return new Promise<AccessibilityImages>((resolve, reject) => {
    axios
      .patch(`${process.env.REACT_APP_API_DOMAIN}/accessibility-images/${id}/`, isEmptyFormData ? data : formData,
        { headers: { 'Authorization': 'Token ' + token } }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}



